import React, { useState } from "react";
import { Link, NavLink } from "react-router";
import "./header.scss";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__logo-link" onClick={closeMenu}>
          <img src="/images/logo.png" alt="Logo" className="header__logo" />
        </Link>

        {/* Mobile Hamburger Button */}
        <button
          className={`header__hamburger ${
            isMenuOpen ? "header__hamburger--open" : ""
          }`}
          onClick={toggleMenu}
          aria-label="Toggle Navigation Menu"
        >
          <span className="header__hamburger-bar"></span>
          <span className="header__hamburger-bar"></span>
          <span className="header__hamburger-bar"></span>
        </button>

        {/* Navigation Menu */}
        <nav
          className={`header__navigation ${
            isMenuOpen ? "header__navigation--open" : ""
          }`}
        >
          <ul className="header__list">
            <li className="header__item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `header__link ${isActive ? "header__link--active" : ""}`
                }
                onClick={closeMenu}
              >
                Strona Główna
              </NavLink>
            </li>
            <li className="header__item">
              <NavLink
                to="/o-nas"
                className={({ isActive }) =>
                  `header__link ${isActive ? "header__link--active" : ""}`
                }
                onClick={closeMenu}
              >
                O nas
              </NavLink>
            </li>
            <li className="header__item">
              <NavLink
                to="/oferta"
                className={({ isActive }) =>
                  `header__link ${isActive ? "header__link--active" : ""}`
                }
                onClick={closeMenu}
              >
                Oferta
              </NavLink>
            </li>
            <li className="header__item">
              <NavLink
                to="/galeria"
                className={({ isActive }) =>
                  `header__link ${isActive ? "header__link--active" : ""}`
                }
                onClick={closeMenu}
              >
                Galeria
              </NavLink>
            </li>
            <li className="header__item">
              <NavLink
                to="/kontakt"
                className={({ isActive }) =>
                  `header__link ${isActive ? "header__link--active" : ""}`
                }
                onClick={closeMenu}
              >
                Kontakt
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
